import { createStyles, makeStyles, Theme } from "@material-ui/core";
import styled from "styled-components";

export const useFormStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "block",
      margin: "auto",
      minHeight: "560px",
    },
    rootDC: {
      display: "block",
      margin: "auto",
      height: "52vh",
      overflowY: "auto",
    },
    rootNT: {
      display: "block",
      margin: "auto",
      height: "50vh",
      overflowY: "auto",
      marginTop: "30px",
    },
    recapRoot: {
      display: "block",
      margin: "25px auto",
    },
    viewStep: {
      margin: "0 2rem",
    },
    input: {
      padding: "20px 16px !important",
    },
    formTitle: {
      width: "auto",
      height: "29px",
      margin: "auto",
      fontSize: "22px",
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      textAlign: "center",
      color: "#399ebf",
      left: "-55px",
      position: "relative",
    },
    NTFormTitle: {
      width: "auto",
      height: "29px",
      margin: "auto",
      fontSize: "17px",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "30px",
      letterSpacing: "normal",
      textAlign: "center",
      color: "#399ebf",
      position: "relative",
    },
    formHeader: {
      display: "flex",
      alignItems: "center",
      padding: "10px",
      justifyContent: "space-between",
    },
    cancelButton: {
      fontSize: "20px",
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#399ebf",
    },
    formInput: {
      border: "solid 1px #757a93",
      margin: "13px 0 0",
      padding: "2px 0 3px 26px",
      width: "470px",
      height: "50px",
      alignSelf: "center",
    },
    vehiculeTypeLabel: {
      maxWidth: "70%",
      color: "#757a93",
      fontSize: "20px",
    },
    vehiculeTypeCount: {
      right: 0,
    },
    vehiculeTypeItem: {
      display: "flex",
      width: "100%",
      justifyContent: "space-between",
      margin: "15px 0",
      alignItems: "flex-start",
    },
    formNextBtn: {
      width: "120px",
      height: "45px",
      backgroundColor: "#399ebf",
      color: "#fff",
      float: "inline-end",
      marginLeft: "auto",
    },
    formPrevBtn: {
      width: "170px",
      height: "43px",
      border: "solid 1px #399ebf",
      backgroundColor: "#cfecf8",
      color: "#399ebf",
      marginRight: "10px",
    },
    formFooter: {
      margin: "auto",
      border: "none",
    },
    requestForm: {
      width: "35vw",
      margin: "auto",
      position: "relative",
      top: 15,
      bottom: 20,
    },
    item: {
      padding: "20px 0 !important",
    },
    productContainer: {
      borderRadius: "10px",
      width: "95%",
      display: "block",
      margin: "auto",
      minHeight: "200px",
      border: "solid 1px #ccc",
      marginTop: "20px",
    },
    productContainerStyle: {
      backgroundColor: "#399ebf",
      color: "white",
      margin: 5,
    },
    textarea: {
      height: "inherit !important",
    },
    request_title: {
      height: "29px",
      margin: "0 100px 21px 0",
      fontFamily: "Montserrat",
      fontSize: "24px",
      fontWeight: "bold",
      textAlign: "left",
      color: "#1a224b",
      padding: "20px",
    },
    nt_stops_wrapper: {
      width: "65vw",
      margin: "auto",
      position: "relative",
      top: "10%",
    },
    blue_border: {
      border: "solid 1px #d1e9f0",
      borderRadius: "5px",
      margin: "20px 0",
      padding: "5px",
      width: "99%",
      [theme.breakpoints.down("xs")]: {
        width: "100%",
      },
    },
    swith_container: {
      margin: "auto",
      width: "37%",
      padding: "20px 0",
      [theme.breakpoints.down("xs")]: {
        width: "90%",
        marginLeft: "15px",
      },
    },
    text_info: {
      margin: "auto",
      width: "auto",
      padding: 10,
      textAlign: "center",
    },
    rootPrice: {
      flexGrow: 1,
      margin: "auto",
      maxHeight: "700px",
    },
    stepper: {
      border: "none !important",
      marginBottom: -70,
    },
    nextAction: {
      backgroundColor: " #fff",
      border: "none",
      textAlign: "right",
      zIndex: 1,
      width: "calc(100% + 100px)",
      margin: " 20px 0 20px -50px",
      float: "right",
    },

    vehiculeLabel: {
      marginLeft: 10,
    },
    vehiculeDescription: {
      position: "relative",
      left: -10,
    },
    divStyle: {
      backgroundColor: "#fff",
      height: "81vh",
      borderBottomLeftRadius: "20px",
      borderBottomRightRadius: "20px",
      overflowY: "scroll",
      overflowX: "hidden",
    },
    stopsScroll: {
      height: "48vh",
      overflowY: "auto",
    },
    textStyle: {
      display: "flex",
      padding: "1%",
      color: "#399ebf",
      fontWeight: 600,
      fontSize: "17px",
    }
  })
);

export const DeleteIconWrapper = styled("div")`
  color: #bfbbbe;
  cursor: pointer;
  line-height: 60px;
  &:hover {
    color: red;
  }
`;

export const useProductToPickStyles = makeStyles(()=>
createStyles({
  content: {
    "& .MuiDialog-paper ": {
      width: "53%",
      height: "53%"
    },
    backgroundColor: "rgba(0, 0, 0, 0.4)",
      "& .MuiDialog-paperWidthSm ": {
        maxWidth: "none",
      },
  },
  title: {
    color: "#399ebf",
    fontWeight: "bold",
    fontSize: "20px",
    margin: "11px 0 5px -6px",
  },
})
)

export const useColumnStyles = makeStyles(()=>
createStyles({
  image: { height: "30px", width: "30px", borderRadius: 5, },
  text: { color: "#757a93", fontWeight: "bold", fontSize: "13px", textAlign: "left" },
  description: { color: "#757a93", fontWeight: 500, fontSize: "12px" ,display: "flex"}
})
)
